import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "./api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const { pathname } = useLocation();
  const [items, setItems] = useState(null);

  useEffect(() => {
    let live = true;
    api("/api/content")
      .then((data) => {
        if (live) setItems(data);
      })
      .catch(() => {
        if (live) setItems([]);
      });
    return () => {
      live = false;
    };
  }, [pathname]);

  const ready = Array.isArray(items);
  const value = {
    ready,
    ofKind(kind) {
      if (!ready) return null;
      return items
        .filter((item) => item.kind === kind)
        .sort((a, b) => (a.order || 0) - (b.order || 0) || String(a.title).localeCompare(String(b.title)));
    },
    block(slug) {
      if (!ready) return undefined;
      return items.find((item) => item.slug === slug) || null;
    },
  };

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}

export function useSite() {
  const value = useContext(SiteContext);
  if (!value) throw new Error("useSite must be used inside SiteProvider");
  return value;
}

export function pick(record, fallback) {
  if (record === undefined) return fallback;
  return record;
}
